'use strict';

require('./salesforce.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _marketoForm = require('hellosign/components/marketo-form');

var _marketoForm2 = _interopRequireDefault(_marketoForm);

var _salesforce_logo = require('landing-pages/assets/salesforce_logo.svg');

var _salesforce_logo2 = _interopRequireDefault(_salesforce_logo);

var _clouds_salesforce = require('landing-pages/assets/clouds_salesforce.svg');

var _clouds_salesforce2 = _interopRequireDefault(_clouds_salesforce);

var _cloud_left = require('landing-pages/assets/cloud_left.svg');

var _cloud_left2 = _interopRequireDefault(_cloud_left);

var _cloud_right = require('landing-pages/assets/cloud_right.svg');

var _cloud_right2 = _interopRequireDefault(_cloud_right);

var _handshake_icon = require('landing-pages/assets/handshake_icon.svg');

var _handshake_icon2 = _interopRequireDefault(_handshake_icon);

var _signature_icon = require('landing-pages/assets/signature_icon.svg');

var _signature_icon2 = _interopRequireDefault(_signature_icon);

var _document_send_icon = require('landing-pages/assets/document_send_icon.svg');

var _document_send_icon2 = _interopRequireDefault(_document_send_icon);

var _benefitsSection = require('landing-pages/components/common/benefits-section');

var _benefitsSection2 = _interopRequireDefault(_benefitsSection);

var _socialSection = require('landing-pages/components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _faqSection = require('landing-pages/components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Salesforce(p) {
    // Salesforce constants
    var benefits = [{
        icon: _handshake_icon2['default'],
        title: 'Close Opportunities in Minutes',
        text: 'The average turnaround time for a contract is 44 minutes using HelloSign. Seal deals even faster! And it’s customizable to fit your workflow.'
    }, {
        icon: _signature_icon2['default'],
        title: 'Easily Track the Status of Signatures',
        text: 'Make it easy to organize and follow-up on any eSignature request in Salesforce. The document status is automatically tracked in the HelloSign Signature Requests section.'
    }, {
        icon: _document_send_icon2['default'],
        title: 'Auto-populate High-volume Documents',
        text: 'Pre-fill your documents with Salesforce data using templates and merge fields. Create documents only once, then reuse them without ever leaving Salesforce.'
    }];
    var twitterLink = 'https://twitter.com/intent/tweet?text=Check%20out%20the%20awesome%20HelloSign%20for%20Salesforce%21%20http%3A%2F%2Fwww.hellosign.com%2Fsalesforce%3Futm_campaign%3DSFDC-082016%26utm_medium%3Ds2s%26utm_source%3Dtwitter&source=clicktotweet&related=clicktotweet';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=http%3A//www.hellosign.com/salesforce?utm_campaign=SFDC-072016%26utm_medium=s2s%26utm_source=facebook';
    var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=www.hellosign.com/salesforce?utm_campaign=SFDC-072016%2526utm_medium=s2s%2526utm_source=linkedin&title=Check%20out%20HelloSign%20for%20Salesforce%20Integration!&summary=&source=';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations seo-salesforce' },
        _react2['default'].createElement(IllustrationArea, null),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main bg-white' },
            _react2['default'].createElement(
                'div',
                { className: 'seo-cloud-integrations__main__free_accounts__top bg-plume', style: { fontWeight: 600 } },
                'Get this integration started today.\xA0',
                _react2['default'].createElement(ContactSalesLink, null)
            ),
            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
            _react2['default'].createElement(HowItWorks, null),
            _react2['default'].createElement(_socialSection2['default'], {
                title: 'Share with your networks!',
                twitterLink: twitterLink,
                facebookLink: facebookLink,
                linkedInLink: linkedInLink }),
            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/205929427-SFDC' }),
            _react2['default'].createElement(
                'div',
                { className: 'seo-cloud-integrations__main__free_accounts__bottom', style: { fontWeight: 600 } },
                'Get this integration started today.\xA0',
                _react2['default'].createElement(ContactSalesLink, null)
            )
        )
    );
}

function IllustrationArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'top row dropbox-blue' },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _salesforce_logo2['default'], alt: 'Salesforce Logo' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Send contracts directly from Salesforce\xAE'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    'HelloSign for Salesforce lets you quickly prepare documents for eSignature, minimize the back-and-forth follow-up, and simplify the signing process for your clients.'
                )
            ),
            _react2['default'].createElement(ContactSalesButton, null)
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns salesforce-clouds' },
            _react2['default'].createElement('img', { src: _clouds_salesforce2['default'], alt: 'cloud left' })
        ),
        _react2['default'].createElement('img', { src: _cloud_left2['default'], alt: 'cloud left', className: 'cloud-left' }),
        _react2['default'].createElement('img', { src: _cloud_right2['default'], alt: 'cloud right', className: 'cloud-right' })
    );
}

function HowItWorks(p) {
    var videoProps = {
        src: 'https://www.youtube.com/embed/8MSbsPE2S_o',
        frameBorder: 0,
        style: {
            width: '100%',
            maxWidth: 800,
            height: 430
        }
    };
    var paragraphStyle = {
        marginLeft: 20
    };

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__how-it-works' },
        _react2['default'].createElement(
            'h2',
            null,
            'How it Works'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'div',
                { className: 'screenshot-explanation large-4 large-push-8 columns' },
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'To get started, activate the HelloSign for Salesforce integration.'
                ),
                _react2['default'].createElement(
                    'p',
                    { onClick: handleClick, style: paragraphStyle },
                    _react2['default'].createElement(
                        'span',
                        { style: { color: '#00B3E6', cursor: 'pointer', fontWeight: 400 } },
                        'Contact HelloSign Sales to get started.'
                    )
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'You\u2019ll be able to track your documents in the HelloSign Signature Requests section on the lead, contact, opportunity, or account record. Autofill your documents using templates, and we\u2019ll pull in data from your Salesforce fields.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'dropbox-screenshot large-8 large-pull-4 columns' },
                _react2['default'].createElement('iframe', videoProps)
            )
        )
    );
}

function ContactSalesButton() {
    return _react2['default'].createElement(_button2['default'], {
        buttonText: 'Contact sales',
        buttonColor: 'cerulean',
        buttonBorderColor: 'cerulean',
        buttonHoverColor: 'white',
        buttonHoverTextColor: 'cerulean',
        onClick: handleClick });
}

function ContactSalesLink(p) {
    return _react2['default'].createElement(
        'a',
        { onClick: handleClick },
        'Contact our Sales team.'
    );
}

function handleClick(e) {
    // Click handler to launch contact sales modal
    var attachPoint = HfReactHelper.getRevealAttachPoint('contact_sales_modal');
    var node = _reactDom2['default'].render(_react2['default'].createElement(_marketoForm2['default'], { formId: 1262, trackingId: 'salesforce' }), attachPoint);
    $(document).foundation();
    $(_reactDom2['default'].findDOMNode(node)).closest('.reveal-modal').foundation('reveal', 'open');
}

module.exports = Salesforce;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/salesforce.jsx
 ** module id = 1615
 ** module chunks = 0
 **/